import React, {useEffect, useState} from 'react';
import {CustomDivider, StyledPopUp} from "../../../../../shared";
import { SpecificationsPopUpProps} from "../../../models";
import {Button, Divider, Flex, List} from "antd";
import SpecificationsPopUPCard from "./SpecificationsPopUPCard";

const SpecificationsPopUp = ({open, onCansel,product}: SpecificationsPopUpProps) => {
    const [data, setData] = useState<any[]>([])

    useEffect(() => {
        setData(product?.productProperties)
    }, [product]);

    return (
        <StyledPopUp
            open={open}
            onCancel={onCansel}
            title={
                <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ fontSize: "18px", fontWeight: 600 }}>مشخصات محصول</span>
                <span style={{ fontSize: "12px", color: "gray", marginTop: "4px" }}>
                    آگهی‌دهنده مشخصات محصول را به صورت زیر اعلام کرده است:
                </span>
                </div>
            }
            width={"100%"}
            footer={null}
            transitionName={''}
            closable={false}
        >
            <Flex vertical gap={"small"} style={{maxHeight: "400px", overflowX: "hidden" ,overflowY: "auto" ,marginTop:"30px"}}>
                <List
                    grid={{
                        gutter: 16,
                        xs: 1,
                        sm: 1,
                        md: 1,
                        lg: 1,
                        xl: 1,
                        xxl: 1,
                    }}
                    dataSource={data}
                    renderItem={(item) => (
                        <List.Item>
                            <SpecificationsPopUPCard title={item?.title} description={item?.value}
                            />
                            <CustomDivider/>
                        </List.Item>
                    )}
                />
                <Button type={"primary"} block size={"large"} onClick={onCansel}>متوجه شدم</Button>
            </Flex>
        </StyledPopUp>
    );
};

export default SpecificationsPopUp;
